import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { PageCloseButtonComponent } from '../../common/close-button/page-close-button.component';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AutocompleteDropdownComponent } from '../../autocomplete-dropdown/autocomplete-dropdown.component';
import { SharedModule } from '../../../modules/shared/shared.module';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { EditableTableComponent } from '../../editable-table/editable-table.component';
import { EditableTableHeader } from '../../../models/editable-table-header.interface';
import paymentConfig from './config/record-payment-config.json'
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';
import { DynamicFormService } from '../../../services/dynamic-form.service';
import { DynamicForm } from '../../../models/dynamic-form';
import { FileUploadComponent } from '../../file-upload/file-upload.component';
import { ApiService } from '../../../services/api.service';
import { PaymentMode } from '../../../constants/app-constants';
import { FinanceApiService } from '../../../services/finance-a-p-iervice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from '../../../services/toaster.service';
import { LoadingService } from '../../../services/loading.service';
import { Stats } from '../../../models/stats.interface';
import { StatsComponent } from '../../stats/stats.component';
import { Customer } from '../../../models/customer-master.interface';
import { StatsService } from '../../../services/stats.service';
import { convertEpochToISTDateTime, getMaxDateForDatePicker, getMaxDateTimeForDatePicker } from '../../../utils/date-time-utils';
import { DatePickerComponent } from '../../common/date-picker/date-picker.component';
import { TosTableService } from "../../../services/tos-table.service";
import { FileUploadService } from "../../../services/file-upload.service";
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-record-payment',
  standalone: true,
  imports: [PageCloseButtonComponent,
    AutocompleteDropdownComponent, SharedModule, EditableTableComponent,
    SvgIconComponent, DynamicFormComponent, FileUploadComponent,
    StatsComponent, DatePickerComponent],
  templateUrl: './record-payment.component.html',
  styleUrl: './record-payment.component.scss'
})
export class RecordPaymentComponent {
  invoiceIds!: string[];
  customerId!: string;
  paymentId!: string;
  paymentForm: FormGroup;
  paymentConfig: DynamicForm;
  isAdvancePayment: boolean = false;
  viewMode: boolean = false;
  transactionFormConfig: DynamicForm[] = [];
  invoiceList: any[] = [];
  selectedInvoiceList: any[] = [];
  tableHeaders: EditableTableHeader[] = [];
  selectedFiles: File[] = [];
  customerStats: Stats[] = [];
  allowedFileTypes: string[] = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/webp",
    "image/bmp",
    "image/tiff"
  ];

  totalAmount: number = 0;
  bankList: any[] = [];
  maxDateTime: string = '';
  maxDate: string = '';
  defaultDateTime: string = '';
  paymentModeOptions = Object.entries(PaymentMode).map(([key, value]) => ({ value: key, label: value.value }));

  totalAmountReceivedVal: number = 0;
  amountUsedForPaymentVal: number = 0;


  // previousState: any = null;
  redirectTo: string = '';


  constructor(private fb: FormBuilder,
    private dynamicFormService: DynamicFormService,
    private api: ApiService,
    private financeApiService: FinanceApiService,
    private router: Router,
    private toasterService: ToasterService,
    private loadingService: LoadingService,
    private statsService: StatsService,
    private route: ActivatedRoute,
    private fileUploadService: FileUploadService,
    private tosTableService: TosTableService,
    private cdr: ChangeDetectorRef,
    ) {
    this.paymentForm = this.fb.group({
      transactions: this.fb.array([])
    });

    this.tableHeaders = paymentConfig.invoiceTableConfig;
    this.paymentConfig = paymentConfig.paymentFormControls;
    this.dynamicFormService.addControlsToForm(this.paymentForm, this.paymentConfig);
  }

   ngOnInit(): void {
    console.log("history.state.recordPaymentInput = ", history.state.recordPaymentInput);
    this.invoiceIds = history.state.recordPaymentInput?.invoiceIds;
    this.redirectTo = history.state.recordPaymentInput.redirectPath;
    this.isAdvancePayment = history.state.recordPaymentInput?.isAdvancePayment ?? false;
    if (this.isAdvancePayment) {
      this.paymentModeOptions = this.paymentModeOptions.filter(option => option.value !== 'PDA');
    }
    this.disablePayingPartyForAdvancedPayment();

    this.configureDateTime();

    this.paymentId = this.route.snapshot.paramMap.get("paymentId") || "";
    if (this.route.snapshot.url[0].path === "view") {
      this.viewMode = true;
      this.loadPaymentDataForView();
    } else {

      this.initialisePaymentData();

      this.getInvoices((invoiceList) => {
        this.invoiceList = invoiceList;
        this.paymentForm.get('customer')?.setValue({key: invoiceList[0]?.customer.id, value: invoiceList[0]?.customer.name});
        this.loadingService.hide();
      });
    }
  }

  private async initialisePaymentData(): Promise<void> {
    this.bankList = await this.fetchBankOptions();
    this.addNewPayment();
  }

  get paymentFormList(): FormArray {
    return this.paymentForm.get('transactions') as FormArray;
  }

  addNewPayment() {
    this.transactionFormConfig.push(JSON.parse(JSON.stringify(paymentConfig.transcationFormControls)));
    const lastIndex = this.transactionFormConfig.length - 1;
    this.populateOptions(lastIndex);
    this.dynamicFormService.addControlsToFormArray(this.paymentFormList, this.transactionFormConfig[lastIndex]);
  }

  private disablePayingPartyForAdvancedPayment(): void {
    if (this.isAdvancePayment)
        this.paymentForm.get('payingParty')?.disable();
  }

  populateOptions(index: number): void {
    // Populate the bank options
    const receivingBankField = this.transactionFormConfig[index]?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === 'receivingBankName');
    const draweeBankField = this.transactionFormConfig[index]?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === 'payerBankName');
    const paymentModeField = this.transactionFormConfig[index]?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === 'paymentMode');
    const transactionDateField = this.transactionFormConfig[index]?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === 'transactionDate');
    if (transactionDateField?.control) {
      transactionDateField.control.maxValue = this.maxDate;
      transactionDateField.control.defaultValue = new Date().toISOString().split('T')[0];
    }
    if (paymentModeField?.control?.fieldInfo?.options) {
      paymentModeField.control.fieldInfo.options = this.paymentModeOptions;
    }
    if (receivingBankField?.control?.fieldInfo?.options) {
      receivingBankField.control.fieldInfo.options = this.bankList;
    }
    if (draweeBankField?.control?.fieldInfo?.options) {
      draweeBankField.control.fieldInfo.options = this.bankList;
    }
  }

  updateBranchOptions(branchList: any[], controlName: string, index: number) {
    const field = this.transactionFormConfig[index]?.formRows.flatMap(row => row.formGroups).find((formGroup: any) => formGroup?.control?.label === controlName);
    if (field?.control?.fieldInfo?.options) {
      field.control.fieldInfo.options = branchList.map(bank => ({ value: bank.id, label: bank.branch }));
    }
  }

  async fetchBankOptions(): Promise<any[]>  {
    this.loadingService.show();
    try {
      const res = await firstValueFrom(this.api.listAllBanks());
      return res.data.map((bank: any) => ({ value: bank, label: bank }));
    } catch (err: any) {
      this.toasterService.error(err.error?.errorDesc || 'Error validating symbol');
      return [];
    } finally {
      this.loadingService.hide();
    }
  }

  getBranchesByBankName(bankName: string, callback: (branchList: any[] | null) => void): void {
    this.api.listBranchesByBankName(bankName).subscribe({
      next: (response: any) => {
        callback(response.data);
      },
      error: (error) => {
        console.error(error);
        callback(null);
      }
    });
  }

  getInvoices(callback: (invoiceList: any[]) => void): void {
    if (this.customerId) {
      this.loadingService.show();
      this.financeApiService.getInvoiceByCustomerId(this.customerId).subscribe({
        next: (response: any) => {
          callback(response.data);
        },
        error: (error) => {
          console.error(error);
          this.toasterService.error(error.error.errorDesc);
          this.loadingService.hide();
          callback([]);
        }
      });
    } else if (this.invoiceIds?.length && this.invoiceIds.length > 0) {
      this.loadingService.show();
      this.financeApiService.getInvoiceByIds(this.invoiceIds).subscribe({
        next: (response: any) => {
          callback(response.data);
        },
        error: (error) => {
          console.error(error);
          this.loadingService.hide();
          callback([]);
        }
      });
    } else {
      callback([]);
    }
  }

  private loadPaymentDataForView(): void {
    this.loadingService.show();
    this.financeApiService.getPayment(this.paymentId).subscribe({
      next: (response) => {
        const payment = response.data;
        this.processPayment(payment);
      },
      error: (error) => {
        console.error(error);
        this.toasterService.error(error.error?.errorDesc || "Failed to load payment");
        this.loadingService.hide();
      }
    });
  }

  private processPayment(payment: any): void {
    payment.transactions.forEach((tx: any) => {
      this.addNewPayment();
    });

    this.hydrateFormBase(payment);

    if (!payment.invoicePayments?.length) {
      this.isAdvancePayment = true;
      this.loadingService.hide();
      return;
    }
  
    this.invoiceIds = payment.invoicePayments.map((ip: any) => ip.invoiceId);
    this.getInvoices((invoiceList: any[]) => {
      this.hydrateInvoices(payment, invoiceList);
      this.loadingService.hide();
      this.paymentForm.disable();
    });
  }

  private hydrateFormBase(payment: any): void {
    this.paymentForm.patchValue({
      ...payment,
      payingParty: { key: payment.payingParty.id, value: payment.payingParty.name },
      paymentDate: convertEpochToISTDateTime(new Date(payment.paymentDate).getTime()),
      transactions: payment.transactions.map((tx: any) => ({
        ...tx,
        transactionDate: new Date(tx.transactionDate).toISOString().split('T')[0],
        payerBankName: [{ value: tx.payerBankName, label: tx.payerBankName }],
        payerBank: [{ value: tx.payerBank, label: tx.payerBankBranch }],
        receivingBankName: [{ value: tx.receivingBankName, label: tx.receivingBankName }],
        receivingBank: [{ value: tx.receivingBank, label: tx.receivingBankBranch }],
      })),
    });
    this.paymentForm.disable();
  }

  private hydrateInvoices(payment: any, invoiceList: any[]): void {
    this.invoiceList = payment.invoicePayments.map((ip: any) => {
      const invoiceDetails = invoiceList.find(inv => inv.id === ip.invoiceId);
      return {
        id: ip.invoiceId,
        invoiceDate: invoiceDetails?.invoiceDate,
        invoiceNo: ip.invoiceNo || invoiceDetails?.invoiceNo,
        amountPaid: ip.totalAmount,
        tdsAmount: ip.tdsAmount,
        writeOffAmount: ip.writeOff,
        ...invoiceDetails,
      };
    });
  }

  getCustomerDetails(customerId: string, callback: (customer: Customer | null) => void): void {
    this.loadingService.show();
    this.api.getCustomer(customerId).subscribe({
      next: (response: any) => {
        callback(response.data);
        this.loadingService.hide();
      },
      error: (error) => {
        console.error(error);
          this.toasterService.error(error.error.errorDesc);
          callback(null);
          this.loadingService.hide();
      }
    });
  }

  customerSelectionCleared(controlName: string) {
    if (controlName === 'customer' && !this.isAdvancePayment) {
      this.invoiceList.length = 0;
    } else {
      this.customerStats.length = 0;
    }
  }

  handleValueChange(index: number, event: any): void {
    const {controlName, result} = event;

    if (controlName === 'receivingBankName' || controlName === 'payerBankName') {
      this.getBranchesByBankName(result.value, (branchList) => {
        this.updateBranchOptions(branchList || [], controlName === 'receivingBankName' ? 'receivingBank' : 'payerBank', index);
      });
    } else if (controlName === 'customer' && !this.isAdvancePayment) {
      this.customerId = result.id;
      this.getInvoices((invoiceList) => {
        this.invoiceList = invoiceList;
        this.loadingService.hide();
      });
    } else if (controlName === 'customer' || controlName === 'payingParty') {
      this.customerStats = this.statsService.createStatsForCustomerPDABalance(result);
    }
  }

  setSelectedInvoiceIds(event: any[]): void {
    this.selectedInvoiceList = event;
  }

  configureDateTime() {
    this.maxDateTime = getMaxDateTimeForDatePicker();
    this.maxDate = getMaxDateForDatePicker();
    this.defaultDateTime = convertEpochToISTDateTime(new Date().getTime());
    this.paymentForm.get("paymentDate")?.setValue(this.defaultDateTime);
  }

  get totalAmountReceived(): number {
    this.totalAmountReceivedVal = this.paymentFormList.controls
      .map((control) => Number(control.get('amount')?.value) || 0)
      .reduce((sum, value) => sum + value, 0);
    return this.totalAmountReceivedVal;
  }

  get amountUsedForPayment(): number {
    this.amountUsedForPaymentVal = this.invoiceList.reduce((sum, invoice) => sum + (Number(invoice.amountPaid) || 0), 0);
    return this.amountUsedForPaymentVal;
  }

  getTotalAmountPaid(): number {
    return this.invoiceList.reduce((sum, invoice) =>
      sum + (Number(invoice.amountPaid) || 0) + (Number(invoice.writeOffAmount) || 0) + (Number(invoice.tdsAmount) || 0), 0);
  }

  get excessAmount(): number {
    return this.totalAmountReceived - this.amountUsedForPayment;
  }

  cancel(): void {
    // Close the page
    this.goBack();
  }

  goBack(): void {
    // console.log('Previous State:', this.previousState);
    this.router.navigateByUrl(this.redirectTo);
  }

  saveForm(): void {
    // Validate the form
    console.log("File count: ", this.selectedFiles.length);
    this.paymentForm.markAllAsTouched();
    if (this.paymentForm.invalid) {
      return;
    }
    if (!this.isValidRequest()) {
      return;
    }
    this.uploadFilesAndSubmitPayment();
  }

  private isValidRequest(): boolean {
    if (!this.isAdvancePayment && this.selectedInvoiceList.length === 0) {
      this.toasterService.error('No invoices are selected for the payment');
      return false;
    }
    if (this.amountUsedForPaymentVal > this.totalAmountReceivedVal) {
      this.toasterService.error('Amount used for payment exceeds total amount received');
      return false;
    }
    for (const invoice of this.selectedInvoiceList) {
      const paidAmount = (Number(invoice.amountPaid) || 0) + (Number(invoice.writeOffAmount) || 0) + (Number(invoice.tdsAmount) || 0);

      if (invoice.dueAmount < paidAmount) {
        this.toasterService.error('Amount paid cannot be greater than the due amount for an invoice');
        return false;
      }

      if (invoice.paymentTerm === 'CASH' && invoice.dueAmount != paidAmount) {
        this.toasterService.error('Partial payment is not allowed for the invoice ' + invoice.invoiceNo);
        return false;
      }
    }

    return true;
  }


  uploadFilesAndSubmitPayment(): void {
    const uploadedFileIds: string[] = [];
    const formDataArray = this.createFormDataToSend();

    // If files are selected, upload them first; otherwise, proceed to payment request
    if (formDataArray.length > 0) {
      this.fileUploadService.uploadFilesSequentially(formDataArray, uploadedFileIds).then(() => {
        this.submitPaymentRequest(uploadedFileIds);
      }).catch((error) => {
        this.toasterService.error('File upload failed: ' + error.message);
      });
    } else {
      this.submitPaymentRequest(uploadedFileIds);
    }
  }

  submitPaymentRequest(uploadedFileIds: string[]): void {
    const paymentRequest = this.createPaymentRequest();
    paymentRequest.uploadedFileIds = uploadedFileIds.length > 0 ? uploadedFileIds : null;

    this.financeApiService.recordPayment(paymentRequest).subscribe({
      next: (response: any) => {
      this.toasterService.success('Payment recorded successfully');
      this.goBack();
    }, error: (error) => {
      console.error(error);
      this.toasterService.error(error.error.errorDesc);
    }});
  }

  createPaymentRequest(): any {
    const formData = this.paymentForm.value;
    const requestPayload: any = {
      ...this.paymentForm.value,
      payingParty: this.isAdvancePayment ? formData.customer.key : formData.payingParty.key,
      totalAmount: this.isAdvancePayment ? this.totalAmountReceived : this.getTotalAmountPaid(),
      excessAmount: this.excessAmount,
      invoicePayments: this.selectedInvoiceList.map((invoice: any) => ({
        invoiceId: invoice.id,
        invoiceNo: invoice.invoiceNo,
        totalAmount: invoice.amountPaid,
        tdsAmount: invoice.tdsAmount,
        writeOff: invoice.writeOffAmount,
      })),
    };
    return requestPayload;
  }

  createFormDataToSend(): FormData[] {
    return this.selectedFiles.map((file: File) => {
      const formDataToSend = new FormData();
      formDataToSend.append('file', file);
      formDataToSend.append('fileSource', "PAYMENT_RECEIPT");
      return formDataToSend;
    });
  }

  // hydrateForm(payment: any) {
  //   this.paymentForm.patchValue({
  //     ...payment,
  //     payingParty: {key: payment.payingParty.id, value: payment.payingParty.name},
  //     paymentDate: convertEpochToISTDateTime(new Date(payment.paymentDate).getTime()),
  //     transactions: payment.transactions.map((transaction: any) => ({
  //       ...transaction,
  //       transactionDate: new Date(transaction.transactionDate).toISOString().split('T')[0],
  //       payerBankName: [{value: transaction.payerBankName, label: transaction.payerBankName}],
  //       payerBank: [{value: transaction.payerBank, label: transaction.payerBankBranch}],
  //       receivingBankName: [{value: transaction.receivingBankName, label: transaction.receivingBankName}],
  //       receivingBank: [{value: transaction.receivingBank, label: transaction.receivingBankBranch}],
  //     })),
  //   });


  //   if (!payment?.invoicePayments || payment.invoicePayments?.length === 0) {
  //     this.isAdvancePayment = true;
  //     return;
  //   }

  //   this.invoiceList = [];
  //   this.invoiceIds = payment.invoicePayments.map((invoice: any) => invoice.invoiceId);
  //   this.getInvoices((invoiceList: any[]) => {
  //     this.invoiceList = payment.invoicePayments.map((invoicePayment: any) => {
  //       const invoiceDetails = invoiceList.find(inv => inv.id === invoicePayment.invoiceId);
  //       return {
  //         ...invoiceDetails,
  //         id: invoicePayment.invoiceId,
  //         invoiceDate: invoiceDetails?.invoiceDate,
  //         invoiceNo: invoicePayment.invoiceNo || invoiceDetails?.invoiceNo,
  //         amountPaid: invoicePayment.totalAmount,
  //         tdsAmount: invoicePayment.tdsAmount,
  //         writeOffAmount: invoicePayment.writeOff,
  //         
  //       };
  //     });
  //   });

  //   this.paymentForm.disable();
  // }
}
